// @flow

import React from 'react';
import { isObject } from '../../utils';
import FieldController from '../Controller';

export default class ProjectVersionSelectController extends FieldController {
    hasValue = (value: *) => {
        return Array.isArray(value) ? value.length > 0 : isObject(value);
    };

    getInitialValue = () => [];

    formatLabel = (value: *) => {
        const separator = ', ';
        const max = 3;
        const makeLabel = (suffix) => (
            <span>
                <strong>{this.label}:</strong> {suffix}
            </span>
        );

        // no value
        if (!this.hasValue(value)) return this.label;

        // value is object
        if (!Array.isArray(value)) return makeLabel(value.label);

        // value is array
        // create comma separated list of values
        // maximum 3 visible
        const valueMap = value.map((v) => v.label);
        const valueLength = valueMap.length;

        return makeLabel(
            valueLength > max
                ? `${valueMap.slice(0, max).join(separator)} +${valueLength - max} more`
                : valueMap.join(separator),
        );
    };
}
